var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrainingVideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "training-video-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 58.549,
    height: 59.402,
    viewBox: "0 0 58.549 59.402",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_65507",
    "data-name": "Path 65507",
    d: "M1,44.786a1.17,1.17,0,0,1,0-2.315H5.332V6.856H1A1.087,1.087,0,0,1,0,5.7,1.087,1.087,0,0,1,1,4.541H28.219V1.157a1.011,1.011,0,1,1,2,0V4.541H57.439a1.087,1.087,0,0,1,1,1.157,1.088,1.088,0,0,1-1,1.157H53.174V42.471h4.374a1.17,1.17,0,0,1,0,2.315H30.378v5.291a1.61,1.61,0,0,1,.138.127l6.252,6.878a1.282,1.282,0,0,1,.033,1.631.9.9,0,0,1-1.41.039l-5.013-5.511v5a1.011,1.011,0,1,1-2,0V53.02l-5.218,5.737a.907.907,0,0,1-1.41-.039,1.282,1.282,0,0,1,.033-1.631l6.257-6.878a1.062,1.062,0,0,1,.338-.248V44.786ZM29.277,15.454c4.422,0,8.01,4.15,8.01,9.265s-3.588,9.265-8.01,9.265-8.01-4.15-8.01-9.265,3.588-9.265,8.01-9.265Zm4.1,9.314-6.385-4.806v9.86l6.385-5.054ZM7.333,42.471H51.172V6.856H7.333V42.471Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainingVideoIcon);
export default __webpack_public_path__ + "static/media/training-video-icon.0e891d04d6cb6fcad818a8536975e87a.svg";
export { ForwardRef as ReactComponent };